import { GridActionsCellItem } from "@mui/x-data-grid";
import { ConfirmationDialog } from "components/dialogs";
import React, { useState } from "react";

const DialogActionItem = ({handler, title, text, children, ...props}) => {

  const [open, setOpen] = useState(false);

  const okHandler = () => { 
    handler();
    setOpen(false);
  };

  const cancelHandler = () => {
    setOpen(false);
  };

  return (
    <>
      <GridActionsCellItem {...props} onClick={ () => setOpen(true) } />
      <ConfirmationDialog 
        open={open}
        onOk={okHandler}
        onCancel={cancelHandler}
        title={title}
        text={children ?? text}
      />  
    </>
  )
}

export default DialogActionItem;